/* Rätsel-Adventskalender: Minispiel »Kreis ihn ein!« (Sektion rk-ermittlung).
   Pro Fall liegen Text und Aufträge im Markup (script[data-fall-daten]); dieses Skript macht die Indizien
   klickbar, führt durch die Aufträge, blättert um und zeigt Bilanz und Kaufbox. */
(function () {
  'use strict';
  if (window.RkErmittlung) { window.RkErmittlung.alle(); return; }

  var SCHEIN = [0, .045, .08, .12];   // wie stark die Rückseite durchscheint
  var GLUT = [0, .16, .27, .38];      // Kerzenlicht hinter dem Blatt
  var KRINGEL = [
    'M .17 .2 C .4 .02 .82 .06 .93 .36 C 1.03 .62 .83 .93 .48 .93 C .16 .93 .02 .72 .06 .46 C .09 .24 .29 .11 .56 .11',
    'M .83 .16 C .63 .02 .22 .06 .09 .34 C -.01 .6 .18 .95 .52 .93 C .83 .9 .99 .66 .94 .4 C .9 .2 .72 .09 .43 .13',
    'M .12 .3 C .25 .06 .75 0 .92 .28 C 1.02 .48 .9 .9 .53 .95 C .22 .99 .03 .77 .07 .48 C .09 .32 .19 .19 .34 .15'
  ];
  var STRICH = 'M .08 .84 Q .5 .55 .92 .14';
  var UNTERSTRICH = 'M 0 .55 C .2 .2 .42 .9 .62 .5 S .9 .25 1 .45';
  var NS = 'http://www.w3.org/2000/svg';
  var ruhig = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

  function melde(fall, name, daten) {
    window.dataLayer = window.dataLayer || [];
    var e = { event: 'kalenderblatt_' + name, blatt: fall };
    for (var k in daten) { if (daten[k] !== undefined) e[k] = daten[k]; }
    window.dataLayer.push(e);
  }
  function skaliere(norm, w, h, pad) {
    var i = 0;
    return norm.replace(/-?\d*\.?\d+/g, function (n) {
      var v = parseFloat(n);
      return ((i++ % 2 === 0) ? pad + v * (w - 2 * pad) : pad + v * (h - 2 * pad)).toFixed(1);
    });
  }
  function zeichne(svg) {
    var w = svg.clientWidth, h = svg.clientHeight;
    if (!w || !h) return;
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.querySelectorAll('path[data-norm]').forEach(function (p) { p.setAttribute('d', skaliere(p.getAttribute('data-norm'), w, h, 2)); });
  }
  function pfad(norm, klasse) {
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('data-norm', norm); p.setAttribute('pathLength', '1');
    if (klasse) p.setAttribute('class', klasse);
    return p;
  }
  function plural(n, eins, viele) { return n === 1 ? '1 ' + eins : n + ' ' + viele; }
  function kopfHoehe() {
    var kopf = document.querySelector('.rk-kopf');
    return kopf ? Math.round(kopf.getBoundingClientRect().height) : 76;
  }

  /* Zeichenblock für das Krimi-Finale */
  function Zeichenblock(canvas, zaehler, leer) {
    var ctx = canvas.getContext('2d'), striche = [], aktuell = null, dpr = 1;
    function groesse() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;
      dpr = window.devicePixelRatio || 1;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      male();
    }
    function linie(pts, w, h) {
      ctx.beginPath();
      if (pts.length === 1) { ctx.arc(pts[0][0] * w, pts[0][1] * h, 1.6, 0, Math.PI * 2); ctx.fill(); return; }
      ctx.moveTo(pts[0][0] * w, pts[0][1] * h);
      for (var i = 1; i < pts.length - 1; i++) {
        ctx.quadraticCurveTo(pts[i][0] * w, pts[i][1] * h, (pts[i][0] + pts[i + 1][0]) / 2 * w, (pts[i][1] + pts[i + 1][1]) / 2 * h);
      }
      var l = pts[pts.length - 1]; ctx.lineTo(l[0] * w, l[1] * h); ctx.stroke();
    }
    function male() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);
      ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.8;
      ctx.strokeStyle = ctx.fillStyle = getComputedStyle(canvas).color;
      striche.forEach(function (s) { linie(s, w, h); });
      if (aktuell) linie(aktuell, w, h);
    }
    function punkt(e) { var r = canvas.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; }
    function zaehle() { zaehler.textContent = plural(striche.length, 'Strich', 'Striche'); leer.hidden = striche.length > 0 || !!aktuell; }
    canvas.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault(); canvas.setPointerCapture(e.pointerId);
      aktuell = [punkt(e)]; leer.hidden = true; male();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!aktuell) return;
      var p = punkt(e), l = aktuell[aktuell.length - 1];
      if (Math.abs(p[0] - l[0]) + Math.abs(p[1] - l[1]) < .004) return;
      aktuell.push(p); male();
    });
    function ende() { if (!aktuell) return; striche.push(aktuell); aktuell = null; male(); zaehle(); }
    canvas.addEventListener('pointerup', ende);
    canvas.addEventListener('pointercancel', ende);
    return {
      groesse: groesse,
      loeschen: function () { striche = []; aktuell = null; male(); zaehle(); },
      anzahl: function () { return striche.length; },
      bild: function () { return canvas.toDataURL('image/png'); }
    };
  }

  /* Ein Fall = Blatt + Akte + Spielstand */
  function starteFall(root, cfg, sage) {
    var teil = function (n) { return root.querySelector('[data-teil="' + n + '"]'); };
    var aktion = function (n) { return root.querySelector('[data-aktion="' + n + '"]'); };
    var buehne = teil('buehne'), vorne = teil('vorne'), hinten = teil('hinten');
    var el = {
      nr: teil('nr'), frageText: teil('frage-text'), frage: teil('frage'), anweisung: teil('anweisung'), notiz: teil('notiz'),
      spiel: teil('spiel'), bereit: teil('bereit'), ergebnis: teil('ergebnis'), kauf: teil('kauf'), liste: teil('liste'),
      stempel: teil('stempel'), bilanz: teil('bilanz'), satz: teil('satz'), sperre: teil('sperre'), fuss: teil('fuss'),
      zeichnung: teil('zeichnung'), zeichnungBild: teil('zeichnung-bild'), moranFrage: teil('moran-frage'),
      tipp: aktion('tipp'), umblaettern: aktion('umblaettern'), seite: aktion('seite')
    };
    var A = cfg.auftraege, S;
    var block = (cfg.zeichnen && teil('leinwand')) ? Zeichenblock(teil('leinwand'), teil('zaehler'), teil('leer')) : null;

    // Ringbindung
    var r = cfg.ringe, html = '';
    for (var k = 0; k < r.n; k++) {
      var cx = r.x0 + r.dx * k;
      html += '<path d="M' + (cx + 6) + ' 0 V-11 Q' + (cx + 6) + ' -23 ' + cx + ' -23 Q' + (cx - 6) + ' -23 ' + (cx - 6) + ' -11" fill="none" stroke="#2f3336" stroke-width="5.5" stroke-linecap="round"/>' +
              '<path d="M' + (cx - 6) + ' -11 V' + r.lochY + '" fill="none" stroke="#5f666b" stroke-width="5.5" stroke-linecap="round"/>' +
              '<path d="M' + (cx - 7.2) + ' -12 V' + (r.lochY - 4) + '" fill="none" stroke="#c3c9cd" stroke-width="1.6" stroke-linecap="round"/>';
    }
    teil('ringe').innerHTML = html;

    // Indizien zu Schaltflächen machen
    var knoepfe = {};
    root.querySelectorAll('span.indiz').forEach(function (span, i) {
      var id = span.getAttribute('data-indiz');
      var b = document.createElement('button');
      b.type = 'button'; b.className = span.className; b.setAttribute('data-indiz', id);
      b._klasse = span.className;
      var wort = document.createElement('span'); wort.className = 'indiz__wort'; wort.innerHTML = span.innerHTML;
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'kringel'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      svg.appendChild(pfad(KRINGEL[i % KRINGEL.length], 'kringel__linie'));
      svg.appendChild(pfad(STRICH, 'kringel__strich'));
      var nr = document.createElement('span'); nr.className = 'indiz__nr'; nr.setAttribute('aria-hidden', 'true');
      b.appendChild(wort); b.appendChild(svg); b.appendChild(nr);
      b.addEventListener('click', function () { kreise(id, b); });
      span.replaceWith(b);
      knoepfe[id] = b;
    });
    var istWort = function (b) { return b.classList.contains('indiz--wort'); };

    // Unterstreichungen der Rückseite
    root.querySelectorAll('.spur').forEach(function (s) {
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'unterstrich'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      svg.appendChild(pfad(UNTERSTRICH));
      var nr = document.createElement('span'); nr.className = 'spur__nr'; nr.setAttribute('aria-hidden', 'true');
      nr.textContent = String(+s.getAttribute('data-spur') + 1);
      s.appendChild(svg); s.appendChild(nr);
    });

    // Die Rückseite scheint spiegelverkehrt durch
    var geist = teil('geist');
    teil('bericht').querySelectorAll('p').forEach(function (p) {
      var q = document.createElement('p'); q.textContent = p.textContent; geist.appendChild(q);
    });

    function zeichneAlle() {
      root.querySelectorAll('svg.kringel, svg.unterstrich').forEach(zeichne);
      if (block && !el.bereit.hidden) block.groesse();
    }
    function neuerStand() { return { auftrag: 0, gefunden: {}, fehl: 0, fehlHier: 0, tipps: 0, tippHier: false, start: null, dauer: 0, zustand: 'spielen', hinten: false }; }
    function gefunden(a) { return a.loesung.filter(function (id) { return S.gefunden[id] !== undefined; }); }
    function geloest(a) { return gefunden(a).length >= (a.noetig || a.loesung.length); }
    function notiz(text, art) { el.notiz.textContent = text; el.notiz.className = 'akte__notiz' + (art ? ' is-' + art : ''); }

    function baueListe() {
      el.liste.innerHTML = '';
      A.forEach(function (a, i) {
        var li = document.createElement('li');
        li.innerHTML = '<span class="liste__nr">' + (i + 1) + '</span><span class="liste__label"></span><span class="liste__wert is-offen">noch offen</span>';
        li.querySelector('.liste__label').textContent = a.label;
        el.liste.appendChild(li);
      });
    }
    function aktualisiereListe() {
      var lis = el.liste.children;
      A.forEach(function (a, i) {
        var gef = gefunden(a).map(function (id) { return cfg.worte[id] || id; });
        var wert = lis[i].querySelector('.liste__wert');
        if (gef.length) { wert.textContent = gef.join(', '); wert.className = 'liste__wert'; }
        else { wert.textContent = (S.zustand === 'aufgegeben') ? 'nicht ermittelt' : 'noch offen'; wert.className = 'liste__wert is-offen'; }
        lis[i].classList.toggle('is-aktiv', S.zustand === 'spielen' && i === S.auftrag);
      });
    }
    function setzeWoerter(an) {
      Object.keys(knoepfe).forEach(function (id) {
        var b = knoepfe[id];
        if (istWort(b) && !b.classList.contains('is-gefunden')) b.disabled = !an;
      });
      if (el.moranFrage) el.moranFrage.classList.toggle('is-fokus', !!an);
    }
    function zeigeAuftrag(neu) {
      var a = A[S.auftrag];
      el.nr.textContent = 'Auftrag ' + (S.auftrag + 1) + ' von ' + A.length;
      el.frageText.textContent = a.frage;
      el.anweisung.textContent = a.anweisung;
      el.tipp.classList.remove('is-hervor');
      setzeWoerter(!!a.woerter);
      if (neu && !ruhig()) { el.frage.classList.remove('is-neu'); void el.frage.offsetWidth; el.frage.classList.add('is-neu'); }
      var rest = A.length - S.auftrag;
      el.sperre.textContent = rest === 1 ? 'noch 1 Indiz' : 'noch ' + rest + ' Indizien';
      aktualisiereListe();
    }
    function setzeSchein(stufe) { root.style.setProperty('--schein', SCHEIN[stufe]); root.style.setProperty('--glut', GLUT[stufe]); }

    /* Einkreisen */
    function kreise(id, b) {
      if (S.zustand !== 'spielen') return;
      if (!S.start) { S.start = Date.now(); melde(cfg.id, 'start'); }
      var a = A[S.auftrag];
      if (S.gefunden[id] !== undefined) { notiz('Schon eingekreist.', 'neutral'); sage('Schon eingekreist.'); return; }
      if (a.loesung.indexOf(id) > -1) {
        S.gefunden[id] = S.auftrag;
        b.querySelector('.indiz__nr').textContent = String(S.auftrag + 1);
        b.classList.remove('is-falsch', 'is-verblasst');
        b.classList.add('is-gefunden');
        b.setAttribute('aria-label', b.querySelector('.indiz__wort').textContent + ', eingekreist');
        melde(cfg.id, 'indiz_richtig', { auftrag: S.auftrag + 1, indiz: id });
        if (!geloest(a)) { notiz(a.teil, 'richtig'); sage(a.teil); aktualisiereListe(); return; }
        S.auftrag++; S.fehlHier = 0; S.tippHier = false;
        setzeSchein(S.auftrag);
        notiz(a.treffer, 'richtig');
        if (S.auftrag === A.length) { bereit(a.treffer); return; }
        zeigeAuftrag(true);
        sage(a.treffer + ' Auftrag ' + (S.auftrag + 1) + ' von ' + A.length + ': ' + A[S.auftrag].frage + ' ' + A[S.auftrag].anweisung);
      } else {
        S.fehl++; S.fehlHier++;
        var grund = a.fehl[id] || (cfg.personen.indexOf(id) > -1 ? a.fehl._person : a.fehl._sache) || 'Diese Spur führt nicht weiter.';
        var text = 'Falsche Fährte. ' + grund;
        if (S.fehlHier >= 2 && !S.tippHier) { text += ' Brauchst du einen Tipp?'; el.tipp.classList.add('is-hervor'); }
        notiz(text, 'falsch'); sage(text);
        falschMarkieren(b);
        melde(cfg.id, 'indiz_falsch', { auftrag: S.auftrag + 1, indiz: id });
      }
    }
    function falschMarkieren(b) {
      clearTimeout(b._t1); clearTimeout(b._t2);
      var svg = b.querySelector('.kringel');
      svg.classList.add('ohne-uebergang'); b.classList.remove('is-falsch', 'is-verblasst'); void svg.getBoundingClientRect(); svg.classList.remove('ohne-uebergang');
      requestAnimationFrame(function () { b.classList.add('is-falsch'); });
      b._t1 = setTimeout(function () { b.classList.add('is-verblasst'); }, 1500);
      b._t2 = setTimeout(function () {
        svg.classList.add('ohne-uebergang'); b.classList.remove('is-falsch', 'is-verblasst');
        void svg.getBoundingClientRect(); svg.classList.remove('ohne-uebergang');
      }, 2000);
    }

    /* Alle Indizien gesichert */
    function bereit(treffer) {
      S.zustand = 'bereit'; S.dauer = Date.now() - S.start;
      el.spiel.hidden = true; el.bereit.hidden = false;
      Object.keys(knoepfe).forEach(function (k) { knoepfe[k].disabled = true; });
      if (el.moranFrage) el.moranFrage.classList.remove('is-fokus');
      if (block) { el.sperre.textContent = 'erst zeichnen, dann umblättern'; block.groesse(); }
      else { el.sperre.hidden = true; zeigeFussKnopf(true); }
      aktualisiereListe();
      sage(treffer + ' Alle Indizien gesichert. ' + (block ? 'Zeichne jetzt deine Lösung, dann blättere um.' : 'Du kannst jetzt umblättern.'));
      melde(cfg.id, 'geloest', { falsche_faehrten: S.fehl, tipps: S.tipps, sekunden: Math.round(S.dauer / 1000) });
      el.umblaettern.focus({ preventScroll: true });
    }
    function zeigeFussKnopf(an) {
      var alt = el.fuss.querySelector('[data-fuss]');
      if (alt) alt.remove();
      if (!an) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'akte__link'; b.setAttribute('data-fuss', '');
      b.textContent = 'Jetzt umblättern';
      b.addEventListener('click', function () { aufloesen(false); });
      el.fuss.appendChild(b);
    }

    /* Umblättern */
    function zeigeSeite(rueckseite) {
      S.hinten = rueckseite;
      el.seite.textContent = rueckseite ? 'Vorderseite ansehen' : 'Zur Auflösung';
      var rr = buehne.getBoundingClientRect(), verz = 0, oben = kopfHoehe() + 34;
      if (rr.top < oben - 50 || rr.top > window.innerHeight * .5) {
        window.scrollTo({ top: window.scrollY + rr.top - oben, behavior: ruhig() ? 'auto' : 'smooth' });
        verz = ruhig() ? 0 : 480;
      }
      clearTimeout(S.blaetterTimer);
      S.blaetterTimer = setTimeout(function () { blaettere(rueckseite); }, verz);
      return verz;
    }
    function blaettere(rueckseite) {
      if (rueckseite) {
        hinten.classList.add('is-sichtbar', 'is-beschattet');
        hinten.inert = false; hinten.removeAttribute('aria-hidden');
        vorne.inert = true; vorne.setAttribute('aria-hidden', 'true');
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          vorne.classList.add('is-weg'); hinten.classList.remove('is-beschattet');
        }); });
      } else {
        vorne.inert = false; vorne.removeAttribute('aria-hidden');
        hinten.inert = true; hinten.setAttribute('aria-hidden', 'true');
        vorne.classList.remove('is-weg');
      }
    }

    function aufloesen(aufgegeben) {
      if (S.zustand !== 'spielen' && S.zustand !== 'bereit') return;
      S.zustand = aufgegeben ? 'aufgegeben' : 'aufgeloest';
      Object.keys(knoepfe).forEach(function (k) { knoepfe[k].disabled = true; });
      if (el.moranFrage) el.moranFrage.classList.remove('is-fokus');
      zeigeFussKnopf(false);
      el.sperre.hidden = true;
      el.spiel.hidden = true; el.bereit.hidden = true;
      root.classList.add('is-abgeschlossen');
      setzeSchein(3);
      var vorlauf = zeigeSeite(true);

      var n = A.filter(geloest).length;
      el.stempel.textContent = aufgegeben ? 'Ungelöst' : 'Fall gelöst';
      if (aufgegeben) {
        el.bilanz.textContent = n + ' von 3 Indizien · vorzeitig umgeblättert';
        el.satz.textContent = cfg.saetze.aufgegeben;
      } else {
        var f = S.fehl === 0 ? 'keine falsche Fährte' : plural(S.fehl, 'falsche Fährte', 'falsche Fährten');
        var t = S.tipps === 0 ? 'ohne Tipp' : plural(S.tipps, 'Tipp', 'Tipps');
        var sek = Math.max(1, Math.round(S.dauer / 1000));
        var zeit = Math.floor(sek / 60) + ':' + String(sek % 60).padStart(2, '0') + ' Min.';
        el.bilanz.textContent = '3 von 3 Indizien · ' + f + ' · ' + t + ' · ' + zeit;
        el.satz.textContent = (S.fehl === 0 && S.tipps === 0) ? cfg.saetze.perfekt : (S.fehl <= 2 && S.tipps <= 1) ? cfg.saetze.gut : cfg.saetze.schwer;
      }
      if (block && el.zeichnung && block.anzahl() > 0) { el.zeichnungBild.src = block.bild(); el.zeichnung.hidden = false; }
      el.ergebnis.hidden = false; el.kauf.hidden = false;
      el.stempel.classList.remove('is-gestempelt'); void el.stempel.offsetWidth;
      setTimeout(function () { el.stempel.classList.add('is-gestempelt'); }, ruhig() ? 0 : vorlauf + 650);
      aktualisiereListe();

      zeichneAlle();
      var verz = ruhig() ? 0 : vorlauf + 900;
      A.forEach(function (a, i) {
        if (!geloest(a)) return;
        setTimeout(function () {
          teil('bericht').querySelectorAll('[data-spur="' + i + '"]').forEach(function (s) { s.classList.add('is-belegt'); });
        }, verz + i * (ruhig() ? 0 : 420));
      });

      sage((aufgegeben ? 'Ungelöst. ' : 'Fall gelöst. ') + 'Die Rückseite mit der Auflösung liegt jetzt vor dir. ' + el.bilanz.textContent);
      setTimeout(function () { hinten.focus({ preventScroll: true }); }, ruhig() ? 0 : vorlauf + 850);
      melde(cfg.id, aufgegeben ? 'aufgegeben' : 'umgeblaettert', { indizien: n, zeichnung: block ? block.anzahl() > 0 : undefined });
    }

    function zuruecksetzen() {
      if (S) clearTimeout(S.blaetterTimer);
      S = neuerStand();
      Object.keys(knoepfe).forEach(function (k) {
        var b = knoepfe[k];
        b.disabled = false; b.className = b._klasse; b.removeAttribute('aria-label');
        b.querySelector('.indiz__nr').textContent = '';
      });
      root.querySelectorAll('.is-belegt').forEach(function (s) { s.classList.remove('is-belegt'); });
      root.classList.remove('is-abgeschlossen');
      el.spiel.hidden = false; el.bereit.hidden = true; el.ergebnis.hidden = true; el.kauf.hidden = true;
      if (el.zeichnung) { el.zeichnung.hidden = true; el.zeichnungBild.removeAttribute('src'); }
      if (block) block.loeschen();
      el.sperre.hidden = false; zeigeFussKnopf(false);
      notiz(cfg.start, '');
      setzeSchein(0);
      vorne.inert = false; vorne.removeAttribute('aria-hidden'); vorne.classList.remove('is-weg');
      hinten.inert = true; hinten.setAttribute('aria-hidden', 'true');
      setTimeout(function () { if (!S.hinten) hinten.classList.remove('is-sichtbar'); }, ruhig() ? 0 : 600);
      zeigeAuftrag(false);
    }

    /* Bedienelemente */
    el.tipp.addEventListener('click', function () {
      if (S.zustand !== 'spielen') return;
      var a = A[S.auftrag];
      if (!S.tippHier) { S.tipps++; S.tippHier = true; melde(cfg.id, 'tipp', { auftrag: S.auftrag + 1 }); }
      el.tipp.classList.remove('is-hervor');
      notiz('Tipp: ' + a.tipp, 'neutral'); sage('Tipp: ' + a.tipp);
    });
    aktion('aufgeben').addEventListener('click', function () { aufloesen(true); });
    el.umblaettern.addEventListener('click', function () { aufloesen(false); });
    el.seite.addEventListener('click', function () { zeigeSeite(!S.hinten); });
    aktion('neu').addEventListener('click', function () {
      zuruecksetzen(); melde(cfg.id, 'neu');
      var rr = root.getBoundingClientRect();
      window.scrollTo({ top: window.scrollY + rr.top - kopfHoehe() - 64, behavior: ruhig() ? 'auto' : 'smooth' });
      setTimeout(function () { var erst = root.querySelector('button.indiz:not(:disabled)'); if (erst) erst.focus({ preventScroll: true }); }, 50);
    });
    if (block && aktion('loeschen')) aktion('loeschen').addEventListener('click', function () { block.loeschen(); sage('Zeichnung gelöscht.'); });
    var form = root.querySelector('.kauf form');
    if (form) form.addEventListener('submit', function () { melde(cfg.id, 'warenkorb', {}); });

    /* Start */
    hinten.classList.remove('is-sichtbar');
    baueListe();
    zuruecksetzen();
    zeichneAlle();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(zeichneAlle);
    if (window.ResizeObserver) new ResizeObserver(function () { zeichneAlle(); }).observe(buehne);
    return { zeichneAlle: zeichneAlle };
  }

  /* Sektion: Fälle starten, Aktenreiter, Kaufleiste */
  var imBild = 0;
  function starteSektion(sek) {
    if (!sek || sek._rkGestartet) return;
    sek._rkGestartet = true;
    sek.classList.add('is-js');
    sek.style.setProperty('--kopf-hoehe', kopfHoehe() + 'px');
    var ansage = sek.querySelector('[data-ansage]');
    var sage = function (text) { if (!ansage) return; ansage.textContent = ''; setTimeout(function () { ansage.textContent = text; }, 30); };
    var faelle = {};
    sek.querySelectorAll('.fall[data-fall]').forEach(function (root) {
      var daten = root.querySelector('script[data-fall-daten]');
      if (!daten) return;
      try { faelle[root.id] = starteFall(root, JSON.parse(daten.textContent), sage); }
      catch (err) { if (window.console) console.error('rk-ermittlung', err); }
    });

    var tabs = [].slice.call(sek.querySelectorAll('.fallwahl [role="tab"]'));
    function waehle(tab, fokus) {
      tabs.forEach(function (t) {
        var an = t === tab, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.tabIndex = an ? 0 : -1;
        if (panel) { panel.hidden = !an; panel.removeAttribute('data-start-verborgen'); }
      });
      if (fokus) tab.focus();
      var f = faelle[tab.getAttribute('aria-controls')];
      if (f) requestAnimationFrame(f.zeichneAlle);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { waehle(t, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); waehle(n, true); }
      });
    });
    if (tabs.length) waehle(tabs[0], false);

    // Feste Kaufleiste der Produktseite ausblenden, solange das Spiel im Bild ist
    if ('IntersectionObserver' in window) {
      var drin = false;
      new IntersectionObserver(function (e) {
        var jetzt = e[0].isIntersecting;
        if (jetzt === drin) return;
        drin = jetzt; imBild += jetzt ? 1 : -1;
        document.documentElement.classList.toggle('rk-ermittlung-im-bild', imBild > 0);
      }, { threshold: 0 }).observe(sek);
    }
  }
  function alle() { document.querySelectorAll('[data-rk-ermittlung]').forEach(starteSektion); }

  window.RkErmittlung = { alle: alle, starte: starteSektion };
  alle();
  document.addEventListener('shopify:section:load', function (e) {
    var sek = e.target.querySelector('[data-rk-ermittlung]');
    if (sek) starteSektion(sek);
  });
})();
